import {combineReducers, Reducer} from 'redux'
import {UsersState} from '@models/user'
import {UsersActionTypes} from '@actions/user';


// Type-safe initialState!
export const initialState: UsersState = {
    allIds: [],
    byId: {},
    loading: false,
    count: 0
};


const byId = (state = initialState.byId, action) => {
    switch (action.type) {
        case UsersActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return {
                ...data.reduce((obj, user) => {
                    obj[user.id] = {
                        ...user,
                        is_fetched: false,
                        ...(state[user.id] || {}), //The data which fetch by id is more than data in Table
                    };
                    return obj;
                }, {})
            };
        }

        case UsersActionTypes.CREATE_SUCCESS: {
            const user = action.payload;
            return {
                ...state,
                [user.id]: user
            };
        }

        case UsersActionTypes.UPDATE_SUCCESS: {
            const user = action.payload;
            return {
                ...state,
                [user.id]: {
                    ...state[user.id],
                    ...user
                }
            };
        }

        case UsersActionTypes.FETCH_ITEM_SUCCESS: {
            const user = action.payload;
            return {
                ...state,
                [user.id]: {
                    ...state[user.id],
                    ...user,
                    is_fetched: true
                },
            };
        }

        case UsersActionTypes.DELETE_SUCCESS:
            return Object.keys(state)
                .filter(id => id !== action.payload.id)
                .reduce((result, current) => {
                    result[current] = state[current];
                    return result;
                }, {});


        default:
            return state;
    }
};


const allIds = (state = initialState.allIds, action) => {
    switch (action.type) {
        case UsersActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return data.map(item => item.id);
        }

        case UsersActionTypes.DELETE_SUCCESS:
            const deletedFormIndex = state.indexOf(action.payload.id);
            return [...state.slice(0, deletedFormIndex), ...state.slice(deletedFormIndex + 1)];

        case UsersActionTypes.CREATE_SUCCESS:
            return [action.payload.id, ...state];

        default:
            return state
    }
};


const count = (state = initialState.count, action) => {
    switch (action.type) {
        case UsersActionTypes.FETCH_SUCCESS: {
            const {meta} = action.payload;
            return meta.total_count;
        }

        case UsersActionTypes.DELETE_SUCCESS:
            return state - 1;

        case UsersActionTypes.CREATE_SUCCESS:
            return state + 1;


        default:
            return state
    }
};

const loading = (state = initialState.loading, action) => {
    switch (action.type) {
        case UsersActionTypes.FETCH_REQUEST: {
            return true;
        }

        case UsersActionTypes.FETCH_SUCCESS:
        case UsersActionTypes.FETCH_ERROR:
            return false;

        default:
            return state
    }
};


const reducer: Reducer<UsersState> = combineReducers({
    byId,
    allIds,
    count,
    loading
});

export {reducer as userReducer}


//Selectors
export const getUsersList = users => users.allIds.map(id => users.byId[id]);

export const getUserById = (users, id) => users.byId[id];